import React, { useState } from 'react';
import { LockIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Field, inputClass } from '../../components/ui/Field';
import { functionLabel, fullName } from '../../utils/labels';
export function AdminSettings() {
  const {
    settings,
    updateSettings,
    pushToast,
    members
  } = useApp();
  const [osnutek, setOsnutek] = useState(settings);
  return <div className="mx-auto max-w-3xl space-y-4" data-id="element-1247" data-mp="2tj04at656eke">
      <div data-id="element-1248" data-mp="2fkjomcqaxdq4">
        <h1 className="text-2xl font-semibold text-ink" data-id="element-1249" data-mp="2fiyswjs93oqo">Nastavitve</h1>
        <p className="mt-0.5 text-sm text-ink-muted" data-id="element-1250" data-mp="2kiuwwj0y7g68">Osnovni podatki zbora in pravila prisotnosti.</p>
      </div>

      <Card className="space-y-4 p-5" data-id="element-1251" data-mp="144btgwd794oh">
        <h2 className="text-base font-semibold text-ink" data-id="element-1252" data-mp="143a8o06dt3tk">Zbor</h2>
        <Field label="Ime zbora" htmlFor="ime" data-id="element-1253" data-mp="1947xgvlwcw41">
          <input id="ime" value={osnutek.imeZbora} onChange={e => setOsnutek({
          ...osnutek,
          imeZbora: e.target.value
        })} className={inputClass} data-id="element-1254" data-mp="191v83xdt7jgy" />
        </Field>
        <Field label="Slogan" htmlFor="slogan" data-id="element-1255" data-mp="2srh08zslqxzb">
          <input id="slogan" value={osnutek.slogan} onChange={e => setOsnutek({
          ...osnutek,
          slogan: e.target.value
        })} className={inputClass} data-id="element-1256" data-mp="2ss9wv7xuk73q" />
        </Field>
      </Card>

      <Card className="space-y-4 p-5" data-id="element-1257" data-mp="31q2gupeik2xg">
        <div data-id="element-1258" data-mp="2xrd48z1aupev">
          <h2 className="text-base font-semibold text-ink" data-id="element-1259" data-mp="2xpik3mxur1bu">Prisotnost</h2>
          <p className="mt-0.5 text-sm text-ink-muted" data-id="element-1260" data-mp="3bihvpduikbe4">
            Opravičene odsotnosti se vedno štejejo kot odsotnost.
          </p>
        </div>
        <div className="grid gap-4 sm:grid-cols-3" data-id="element-1261" data-mp="36jnf8ik0qyx6">
          <Field label="Zelena meja (%)" htmlFor="zelena" data-id="element-1262" data-mp="3lfmm5pve6t0q">
            <input id="zelena" type="number" value={osnutek.pragZelena} onChange={e => setOsnutek({
            ...osnutek,
            pragZelena: Number(e.target.value)
          })} className={inputClass} data-id="element-1263" data-mp="3le1se2gwje3x" />
          </Field>
          <Field label="Oranžna meja (%)" htmlFor="oranzna" data-id="element-1264" data-mp="3sjvrycko0tk9">
            <input id="oranzna" type="number" value={osnutek.pragOranzna} onChange={e => setOsnutek({
            ...osnutek,
            pragOranzna: Number(e.target.value)
          })} className={inputClass} data-id="element-1265" data-mp="1cjadwfvee3t" />
          </Field>
          <Field label="Minimalno št. dogodkov" hint="Semafor se vklopi po tem številu štetih dogodkov." htmlFor="min" data-id="element-1266" data-mp="f4g2i0hjgo07">
            <input id="min" type="number" value={osnutek.minDogodkov} onChange={e => setOsnutek({
            ...osnutek,
            minDogodkov: Number(e.target.value)
          })} className={inputClass} data-id="element-1267" data-mp="k4c1flbdpp8w" />
          </Field>
        </div>
      </Card>

      <Card className="space-y-4 p-5" data-id="element-1268" data-mp="2qw3511t25uqb">
        <h2 className="text-base font-semibold text-ink" data-id="element-1269" data-mp="2jazkun2zvkaw">Članarina</h2>
        <div className="grid gap-4 sm:grid-cols-2" data-id="element-1270" data-mp="2jcapsq86ey3l">
          <Field label="Leto članarine" htmlFor="leto" data-id="element-1271" data-mp="2eipxnet9kycb">
            <input id="leto" type="number" value={osnutek.letoClanarine} onChange={e => setOsnutek({
            ...osnutek,
            letoClanarine: Number(e.target.value)
          })} className={inputClass} data-id="element-1272" data-mp="29ko605hrvqp8" />
          </Field>
          <Field label="Znesek (€)" htmlFor="znesek" data-id="element-1273" data-mp="327955s4hp73c">
            <input id="znesek" type="number" value={osnutek.znesekClanarine} onChange={e => setOsnutek({
            ...osnutek,
            znesekClanarine: Number(e.target.value)
          })} className={inputClass} data-id="element-1274" data-mp="2xbacvtg1j4xn" />
          </Field>
        </div>
      </Card>

      <Card className="space-y-4 p-5" data-id="element-1275" data-mp="1gwsah43xw4u1">
        <h2 className="text-base font-semibold text-ink" data-id="element-1276" data-mp="1gtmo3wmp3h20">Gradiva in dogodki</h2>
        <Field label="Povezava do Google Drive mape" htmlFor="drive" data-id="element-1277" data-mp="1bvl5fct6ljr2">
          <input id="drive" value={osnutek.driveLink} onChange={e => setOsnutek({
          ...osnutek,
          driveLink: e.target.value
        })} className={inputClass} data-id="element-1278" data-mp="30qbljj83oh1s" />
        </Field>
        <Field label="Privzeta lokacija vaj" htmlFor="lokacija" data-id="element-1279" data-mp="2quqps2tmkd0h">
          <input id="lokacija" value={osnutek.privzetaLokacija} onChange={e => setOsnutek({
          ...osnutek,
          privzetaLokacija: e.target.value
        })} className={inputClass} data-id="element-1280" data-mp="2vt20sgvnotka" />
        </Field>
      </Card>

      <Card className="p-5" data-id="element-1281" data-mp="3oebkh6fkfdrg">
        <div className="flex items-center gap-2" data-id="element-1282" data-mp="39jx47dndyigh">
          <LockIcon className="h-4 w-4 text-purple-500" data-id="element-1283" data-mp="39lhw0vibfnan" />
          <h2 className="text-base font-semibold text-ink" data-id="element-1284" data-mp="3ehgq8zqbrziz">Dostop do osebnih podatkov</h2>
        </div>
        <p className="mt-1 text-sm leading-relaxed text-ink-muted" data-id="element-1285" data-mp="1y36zy02iw0pi">
          Dovoljenje je neodvisno od funkcij v zboru — dirigent, tajnik, blagajnik ali član komisije ga ne
          dobi samodejno. Pooblaščeni lahko vidijo naslov, datum rojstva, podatke o dokumentu in posebnosti
          pri prehrani.
        </p>
        <ul className="mt-4 max-h-72 divide-y divide-line overflow-y-auto viva-scroll border-t border-line" data-id="element-1286" data-mp="g63mh5e6fp1i">
          {members.filter(m => m.functions.some(f => f !== 'pevec')).map(m => {
          const ima = osnutek.dostopOsebnihPodatkov.includes(m.id);
          return <li key={m.id} className="flex flex-wrap items-center gap-3 py-2.5" data-id="element-1287" data-mp="2d4bngpcaj0a">
                  <span className="min-w-0 flex-1" data-id="element-1288" data-mp="3tncp7fmf9d2j">
                    <span className="block text-sm font-medium text-ink" data-id="element-1289" data-mp="b822mi8xfloz">{fullName(m)}</span>
                    <span className="block text-[12px] text-ink-muted" data-id="element-1290" data-mp="6gadmc5f5o0y">
                      {m.functions.map(f => functionLabel[f]).join(', ')}
                    </span>
                  </span>
                  {ima && <Badge className="bg-purple-50 text-purple-700 border-purple-200" data-id="element-1291" data-mp="3au8t7nlqeo4r">Ima dostop</Badge>}
                  <button type="button" onClick={() => setOsnutek({
              ...osnutek,
              dostopOsebnihPodatkov: ima ? osnutek.dostopOsebnihPodatkov.filter(x => x !== m.id) : [...osnutek.dostopOsebnihPodatkov, m.id]
            })} className={`rounded-lg border px-3 py-1.5 text-[13px] font-medium transition-colors duration-150 ease-out ${ima ? 'border-line bg-white text-ink-muted hover:bg-canvas' : 'border-green-500 bg-green-500 text-white hover:bg-green-600'}`} data-id="element-1292" data-mp="1du4cvpg99ued">
                    {ima ? 'Odvzemi dostop' : 'Dodeli dostop'}
                  </button>
                </li>;
        })}
        </ul>
      </Card>

      <div className="flex justify-end gap-2" data-id="element-1293" data-mp="9l47fsjt80he">
        <Button variant="secondary" onClick={() => setOsnutek(settings)} data-id="element-1294" data-mp="9jt2vqijiop8">
          Razveljavi
        </Button>
        <Button onClick={() => {
        updateSettings(osnutek);
        pushToast('Nastavitve so shranjene.');
      }} data-id="element-1295" data-mp="4nm6opfy4rkh">
          Shrani nastavitve
        </Button>
      </div>
    </div>;
}